















import {defineComponent} from "@vue/composition-api";
import {createNamespacedHelpers} from "vuex";
import {checkAuthorities} from "@teacherskaya/tools/dist/lib/SecurityHelpers";
import {LoggedInUser} from "@/store/types";
import {MenuItems} from "@/types";
import useLoadingStatus from "@/hooks/useLoadingStatus";
import GoBack from "@/components/GoBack.vue";
import BaseMenu from "@/components/BaseMenu.vue";
import BlockBase from "@/components/BlockBase.vue";
import PageTitle from "@/components/PageTitle.vue";
import BasePageOneColumn from "@/components/BasePageOneColumn.vue";
import {menuItems} from "./config";

const { mapGetters } = createNamespacedHelpers("paymentSystems");

export default defineComponent({
  name: "PageSettings",
  components: { BasePageOneColumn, PageTitle, BlockBase, BaseMenu, GoBack },
  setup() {
    const { loadingStatusShow } = useLoadingStatus();
    return { loadingStatusShow };
  },
  computed: {
    loggedInUser(): LoggedInUser {
      return this.$store.state.loggedInUser;
    },
    menu(): MenuItems {
      return menuItems
        .filter(menuItem => checkAuthorities(this.loggedInUser.authorities, menuItem.requiredAuthorities || []))
        .map(item =>
          item.name === "payments"
            ? {
                ...item,
                hasBadge: !this["hasSetSystem"],
              }
            : item
        );
    },
    ...mapGetters(["hasSetSystem"]),
  },
  mounted() {
    this.loadingStatusShow([Promise.resolve()]);
  },
  created() {
    if (this.$route.name === "settings") {
      if (this.menu.length === 0) {
        this.$router.replace({ name: "dashboard" });
      } else if (this.menu[0].route) {
        this.$router.replace(this.menu[0].route);
      }
    }
  },
});
